<template>
  <div class="form-select">
    <FormTitle
      :required="Boolean(data.is_must_answer)"
      :title="data.title"
      :desc="data.title_details"
    />
    <gkFormCustomGroup
      :field="field"
      :rule="isValidity ? rules : []"
      :validity="isValidity"
      v-model="gkFormCustomGroupVal"
    >
      <div class="select-wrap">
        <div class="select" :style="{width: selectWidth}" :data-focus="activeNum === i && showOption" v-for="(selectItem, i) in options" :key="'select-' + i" @click="choiceSelect(i)">
          <!-- <template v-if="!showValue[i] || !showValue[i].value">
            <span class="placeholder">
              {{options.length > 1 ? data.details.options[0].sub_tips[i] : data.tips}}
            </span>
          </template>
          <template v-else>
            {{showValue[i] && showValue[i].value}}
          </template> -->
          <input
            class="search-val"
            type="text"
            v-model="searchVal[i]"
            :placeholder="!showValue[i] || !showValue[i].value
              ? options.length > 1
                ? data.details.options[0].sub_tips[i]
                : data.tips
              : showValue[i] && showValue[i].value
            "
            :readonly="isMobile"
            @click.stop="choiceSelect(i)"
          >
        </div>
      </div>
      <div v-if="showOption">
        <ul class='select-dropdown' :class="showIndex ? 'right' : 'left'">
          <div class="select-dropdown-search-wrap iconfont" v-if="isMobile && this.options[this.showIndex].length > 20">
            <input
              class="select-dropdown-search"
              type="text"
              v-model="searchVal[showIndex]"
              :placeholder="!showValue[showIndex] || !showValue[showIndex].value
                ? options.length > 1
                  ? data.details.options[0].sub_tips[showIndex]
                  : data.tips
                : showValue[showIndex] && showValue[showIndex].value
              "
            >
          </div>
          <template v-if="selectList.length > 0">
            <li :class="{isActive: item.isActive}" v-for='(item, i) in selectList' :key='i' @click="selectVal(item, i)">
              <span>{{item.title}}</span>
            </li>
          </template>
          <template v-else>
            <li>
              <span>暂无数据</span>
            </li>
          </template>
        </ul>
        <div class="cover" @click="closeOption(1)"></div>
      </div>
    </gkFormCustomGroup>
  </div>

</template>
<script>
import {mapState} from 'vuex'
import VueTypes from 'vue-types'
import addressData from '../address'

import gkFormCustomGroup from 'gkui/form/FormCustomGroup'
import FormTitle from '../../../components/FormTitle'

export default {
  name: 'textare-input',
  props: {
    data: VueTypes.object,
    answer: VueTypes.object,
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
    gkFormCustomGroup,
    FormTitle
  },
  data () {
    return {
      // 显示第几个下拉框
      showIndex: 0,
      addressData: addressData,
      // 是否显示下拉框
      showOption: false,
      selectSecond: [],
      activeNum: -1,
      showValue: [],
      gkFormCustomGroupVal: [],
      searchVal: []
      // realTimePlaceHolder: []
    }
  },
  watch: {
    userFieldInfo: {
      handler: function (newData, oldData) {
        try {
        // eslint-disable-next-line camelcase
        const extraInfo = this.data?.extra_info && JSON.parse(this.data.extra_info)
        if (!extraInfo) {
          return
        }
        const { user_attribute: key } = extraInfo
        if (newData !== oldData && key && newData[key]) {
          const value = newData?.[key]
          if (value) {
            const index = this.selectList.findIndex(ele => ele.title === value[0])
            this.selectVal(this.selectList[index], index)
          }
        }
        } catch (e) {
          console.log(e)
        }
      },
      immediate: true
    },
    // searchVal: {
    //   handler: function (nv, ov) {
    //     this.showOption = true
    //   },
    //   deep: true
    // },
    showValue: {
      handler: function (nv, ov) {
        // console.log(nv, ov)
        if (ov && ov.length > nv.length) {
          this.$set(this.searchVal, 1, '')
          // this.$set(this.realTimePlaceHolder, 1, this.options.length > 1 ? this.data.details.options[0].sub_tips[1] : this.data.tips)
        }
        nv.forEach((item, index) => {
          if (!item || !item.value) {
            this.$set(this.searchVal, index, '')
            // this.$set(this.realTimePlaceHolder, index, this.options.length > 1 ? this.data.details.options[0].sub_tips[index] : this.data.tips)
          } else {
            this.$set(this.searchVal, index, item.value)
            // this.$set(this.realTimePlaceHolder, index, item.value)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    rules () {
      let rule = []

      if (this.data.is_must_answer) {
        rule.push({
          required: this.data.tips
        })
      }

      return rule
    },
    // 下拉列表总数据
    options () {
      if (this.data.type === 100800) {
        return [this.data.details.options[0].sub_combo_box, this.selectSecond]
      } else {
        return [this.data.details.options]
      }
    },
    // 实时展示的下拉数据
    selectList () {
      return this.options[this.showIndex].filter(item => item.title.indexOf(this.searchVal[this.showIndex] || '') >= 0)
    },
    isValidity () {
      return Boolean(this.data.showQuestion)
    },
    selectWidth () {
      if (this.isMobile) {
        return '100%'
      } else {
        return '49%'
      }
    },
    field () {
      return this.data.id.toString()
    }
  },
  mounted () {
    // let _this = this

    // document.addEventListener('click', function (e) {
    //   if (e.target.className !== 'select') {
    //     _this.closeOption(1)
    //   }
    // })
  },
  methods: {
    choiceSelect (i, key) {
      this.showIndex = this.activeNum = i
      this.closeOption(0)
    },

    selectVal (item, i) {
      this.options[this.showIndex].forEach(selectOption => {
        selectOption.isActive = false
      })

      item.isActive = true

      let tempValue = this.showValue.slice()

      let _value = {
        key: item.key,
        value: String(item.title)
      }

      // 如果修改第一个框，则置空第二个
      if (this.showIndex === 0 && tempValue[1]) {
        tempValue.splice(1, 1)
        this.showValue = tempValue
        this.gkFormCustomGroupVal = tempValue
        this.selectSecond = []
      }

      // 有二级下拉则创建二级下拉列表
      if (this.data.type === 100800 && item.sub_combo_box) {
        this.selectSecond = item.sub_combo_box

        this.selectSecond.forEach((selectOption) => {
          selectOption.isActive = false
        })
      }

      // 存值
      tempValue.splice(this.showIndex, 1, _value)

      this.showValue = tempValue
      if (this.data.is_must_answer && this.data.type === 100800 && tempValue.length < 2) {
        this.gkFormCustomGroupVal = []
      } else {
        this.gkFormCustomGroupVal = tempValue
      }

      if (this.data.type !== 100800) {
        this.$emit('judgeRule', {qId: this.data.id, qKey: item.key})
      }

      // 关闭下拉框
      this.closeOption(1)
    },

    closeOption (state) {
      this.showOption = !state

      if (this.showOption) {
        this.$set(this.searchVal, this.showIndex, '')
      } else {
        // console.log(this.showValue[this.showIndex])
        this.$set(this.searchVal, this.showIndex, (this.showValue[this.showIndex] && this.showValue[this.showIndex].value) || '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/_common";

.select-wrap {
  display: flex;
  justify-content: space-between;

  & .select {
    position: relative;
    height: 40px;
    padding: 0 11px;
    font-size: 16px; line-height: 40px; color: #4A4A4A;
    border: 1px solid $grayForm; border-radius: 4px;
    @extend %transition;
    @include row(1);

    .placeholder {
      color: rgba(130, 138, 146, 0.6);
    }

    &[data-focus] {
      border-color: $blue;
    }
    &::after {
      content: '';
      position: absolute;
      right: 20px; top: 50%;
      width: 9px; height: 7px;
      background: url('../../../assets/img/form/sanjiao.png') no-repeat center/cover;
      transform: translateY(-50%);
    }
  }

  & .search-val {
    width: calc(100% - 28px);
    border: none;
    line-height: 38px;
  }
}

.select-dropdown {
  box-sizing: border-box;
  position: absolute; z-index: 100; left: 0; top: 48px;
  padding: 10px 0;
  width: 49%; max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #ffffff;
  border: 1px solid $grayForm; border-radius: 4px;
  box-shadow: 0px 3px 6px 0px rgba(170,170,170,0.41);

  &.right {
    left: 346px;
  }

  & li {
    height: 40px;
    padding: 0 10px;
    line-height: 40px;
    font-size: 16px;
    color: $bodyBlack;
    @extend %transition;

    & span {
      @include row(1);
    }

    &.isActive {
      position: relative;
      background: $blueHoverNew;
      color: #fff;

      &::after {
        content: '';
        position: absolute;
        right: 20px; top: 18px;
        width: 11px; height: 6px;
        border-left: 2px solid #fff;
        border-bottom: 2px solid #fff;
        transform: translateY(-50%) rotate(-45deg);
      }
    }

    &:hover {
      background: $blueHoverNew;
      color: #fff;
      @extend %transition;
    }
  }
}

.cover{
  position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
  background-color: transparent;
}

.select-dropdown-search-wrap {
  position: relative;
  height: 40px;
  margin: 0 10px 10px;
  padding: 0 11px;
  font-size: 14px; line-height: 40px; color: #4A4A4A;
  border: 1px solid $grayForm; border-radius: 4px;
  @include row(1);

  &::after {
    content: '\e604';
    position: absolute;
    right: 11px; top: 50%;
    transform: translateY(-50%);
  }

  .select-dropdown-search {
    width: calc(100% - 20px);
    border: none; color: #4A4A4A;
  }
}

@media screen and (max-width: 768px) {
  .select-wrap {
    flex-direction: column;

    & .select {
      width: 100%;
      font-size: 14px;

      &:nth-child(2) {
        margin-top: 10px;
      }

      &::after {
        right: 8px;
      }
    }

    & .search-val {
      width: calc(100% - 14px);
    }
  }

  .select-dropdown {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 50% !important;
    width: 100vw;
    max-height: 60vh;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, 0);

    & li {
      padding: 0 14px;
      font-size: 14px;

      &.isActive:after {
        right: 17px;
      }
    }
  }

  .cover{
    position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
    background-color: #000;
    opacity: .3;
  }
}
</style>
